import { PresentationMode } from '../../../../../../../Enums/PresentationMode';
import { mapAddressFieldsToApiFormat } from '../../../../../../../Helpers/AddressHelper';
import { ServiceClient } from '../../../../../../../Services/ServiceClient';
import { teamPageReducerTypes } from '../../../../../Reducer';
import { addressReducerTypes } from '../../Reducer';

export const onSubmit = (
  event,
  agentCode,
  codePrefix,
  isModalOpenedOnTeamLevel,
  address,
  setModalMode,
  addressDispatch,
  teamPageDispatch
) => {
  event.preventDefault();

  if (isModalOpenedOnTeamLevel) {
    ServiceClient.createAddressForTeam(codePrefix, mapAddressFieldsToApiFormat(address), addressId => {
      handleSuccessfulCreateResult(
        { ...address, id: addressId },
        codePrefix,
        isModalOpenedOnTeamLevel,
        addressDispatch,
        teamPageDispatch
      );
    });
  } else {
    ServiceClient.createAddressForAgent(agentCode, mapAddressFieldsToApiFormat(address), addressId => {
      handleSuccessfulCreateResult(
        { ...address, id: addressId },
        codePrefix,
        isModalOpenedOnTeamLevel,
        addressDispatch,
        teamPageDispatch
      );
    });
  }
  setModalMode(PresentationMode.View);
};

const handleSuccessfulCreateResult = (
  address,
  codePrefix,
  isModalOpenedOnTeamLevel,
  addressDispatch,
  teamPageDispatch
) => {
  ServiceClient.getAddressListForTeam(codePrefix, addressList => {
    addressDispatch({
      type: addressReducerTypes.setNewAddress,
      isModalOpenedOnTeamLevel,
      address,
      addressList,
    });
  });
  teamPageDispatch({
    type: teamPageReducerTypes.updateAddressInfo,
    isModalOpenedOnTeamLevel,
    address,
  });
};
